import { render, staticRenderFns } from "./WelcomAnim.vue?vue&type=template&id=f98a8918&scoped=true&lang=pug&"
import script from "./WelcomAnim.vue?vue&type=script&lang=js&"
export * from "./WelcomAnim.vue?vue&type=script&lang=js&"
import style0 from "./WelcomAnim.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98a8918",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
